import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class SupportService {
    private httpClient: HttpClient;

    constructor(private handler: HttpBackend) {
        this.httpClient = new HttpClient(this.handler);
    }

    sendRequestForm(form) {
        return this.httpClient.post(`api/support/sendEmail`, form);
    }
}
